import Phaser from 'phaser';

export default class Player extends Phaser.Physics.Arcade.Sprite {
  constructor(scene, x, y, texture, config) {
    super(scene, x, y, texture);

    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.config = config;
    this.stats = {
      hp: config.stats.hp,
      maxHp: config.stats.hp,
      attack: config.stats.attack,
      defense: config.stats.defense,
      speed: config.stats.speed,
      mana: config.stats.mana || 50,
      maxMana: config.stats.mana || 50
    };

    this.level = config.level || 1;
    this.faction = config.faction;
    this.class = config.class;

    // Physics settings
    this.setCollideWorldBounds(true);
    this.body.setSize(24, 24);
    this.setDepth(10);

    // Abilities cooldowns
    this.cooldowns = {};
  }

  takeDamage(amount) {
    this.stats.hp -= amount;
    
    // Flash red
    this.setTint(0xFF0000);
    this.scene.time.delayedCall(100, () => {
      const faction = this.scene.registry.get('playerFaction') || 'human';
      const factionColors = {
        human: 0x4CAF50,
        hybrid: 0x9C27B0,
        anunnaki: 0x2196F3,
        giant: 0x795548,
        igigi: 0xFFD700
      };
      this.setTint(factionColors[faction] || 0xFFFFFF);
    });
  }

  heal(amount) {
    this.stats.hp = Math.min(this.stats.hp + amount, this.stats.maxHp);
  }

  useMana(amount) {
    if (this.stats.mana >= amount) {
      this.stats.mana -= amount;
      return true;
    }
    return false;
  }

  useAbility(abilityName) {
    if (this.cooldowns[abilityName]) return false;

    // Set cooldown
    this.cooldowns[abilityName] = true;
    this.scene.time.delayedCall(2000, () => {
      this.cooldowns[abilityName] = false;
    });

    return true;
  }
}
